<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
            data-cy="select-casino"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">* Casino</p>
            <reference
                create-text="Create new casino and link casino to this page"
                link-text="Link an existing casino"
                v-model="form.casino"
                :language="form.language"
                :creatable="false"
                model-data="Casino"
                :should-open-new-window="true"
                :error="errors.casino_id ? errors.casino_id[0] : null"
                :excluded-ids="excludedCasinoIds"
                :query="{
                    'casinoReview.status_id': 1
                }"
                :order="{
                    'casinos.name': 'asc'
                }"
            />
        </div>

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
            data-cy="select-bonus"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">* Bonus</p>
            <reference
                create-text="Create new bonus and link bonus to this page"
                link-text="Link an existing bonus"
                :linkable="true"
                :creatable="false"
                :language="form.language"
                :query="{
                    casino_id: form.casino_id
                }"
                :order="{
                    'bonuses.name': 'asc'
                }"
                v-model="form.bonus"
                field-name="bonuses"
                model-data="Bonus"
                :should-open-new-window="true"
                :error="errors.bonus_id ? errors.bonus_id[0] : null"
            />
        </div>

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "BonusTileForm",
    mixins: [crudForm],
    props: {
        selectedObjects: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            form: {
                casino_id: this.getFormData("casino_id"),
                casino: this.getFormData("casino"),
                bonus_id: this.getFormData("bonus_id"),
                bonus: this.getFormData("bonus"),
            },
        };
    },
    watch:{
        "form.casino": function(newValue){
            this.form.casino_id = newValue?.id || null;
        },
        "form.bonus": function(newValue){
            this.form.bonus_id = newValue?.id || null;
        },
    },
    computed: {
        excludedCasinoIds () {
            if (!this.selectedObjects) return [];
            return this.selectedObjects.map((obj) => obj.casino_id);
        }
    }
};
</script>
